import { invoke } from '@tauri-apps/api/core';
import { QuestSystem } from '../systems/QuestSystem';
import { ActionDef } from '../types/data';
import { isTauriRuntime } from './Environment';

type QuestAction = Extract<ActionDef, { type: 'quest_start' | 'quest_advance' | 'quest_complete' }>;
type PlatformAction = Exclude<ActionDef, QuestAction>;

function isQuestAction(action: ActionDef): action is QuestAction {
  return action.type === 'quest_start' || action.type === 'quest_advance' || action.type === 'quest_complete';
}

async function runWebAction(action: PlatformAction): Promise<string> {
  switch (action.type) {
    case 'open_url': {
      if (action.newTab ?? true) {
        window.open(action.url, '_blank', 'noopener,noreferrer');
      } else {
        window.location.assign(action.url);
      }
      return `URL 열기: ${action.url}`;
    }
    case 'copy_text': {
      await navigator.clipboard.writeText(action.text);
      return '텍스트를 클립보드에 복사했습니다.';
    }
    case 'delay_ms': {
      await new Promise((resolve) => setTimeout(resolve, action.ms));
      return `${action.ms}ms 대기 완료`;
    }
    case 'open_path':
    case 'run':
    case 'run_shell':
      return `[웹] ${action.type} 액션은 지원하지 않습니다.`;
    default:
      return '알 수 없는 액션';
  }
}

export class ActionRunner {
  static async runActions(actions: ActionDef[]): Promise<string[]> {
    const logs: string[] = [];

    for (const action of actions) {
      if (isQuestAction(action)) {
        logs.push(QuestSystem.runAction(action));
      } else if (isTauriRuntime()) {
        const result = await invoke<string[]>('run_actions', { payload: [action] });
        logs.push(...result);
      } else {
        logs.push(await runWebAction(action));
      }
    }
    return logs;
  }
}
